/**
 * <guide-search> — client-side filter for the Guides & FAQ index. Matches the
 * typed query against each card's data-guide-text (title + category), hides
 * non-matching cards and any category group left empty, and toggles a
 * "no results" message. Pure enhancement: without JS every guide is listed.
 */
if (!customElements.get('guide-search')) {
  customElements.define(
    'guide-search',
    class GuideSearch extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.guides__search-input');
        this.cards = [...this.querySelectorAll('[data-guide]')];
        this.groups = [...this.querySelectorAll('[data-guide-group]')];
        this.empty = this.querySelector('[data-guides-empty]');
        if (!this.input) return;

        this.onInput = () => {
          const q = this.input.value.trim().toLowerCase();
          let anyVisible = false;
          for (const card of this.cards) {
            const match = !q || card.dataset.guideText.includes(q);
            card.hidden = !match;
            if (match) anyVisible = true;
          }
          for (const group of this.groups) {
            group.hidden = !group.querySelector('[data-guide]:not([hidden])');
          }
          // Set text (not just unhide) so the role="status" region announces.
          if (this.empty) this.empty.textContent = anyVisible ? '' : this.empty.dataset.message;
        };

        this.input.addEventListener('input', this.onInput);
      }

      disconnectedCallback() {
        if (this.input && this.onInput) this.input.removeEventListener('input', this.onInput);
      }
    }
  );
}
